// assets/offer-bar.js -- <offer-bar> web component. Moved out of snippets/bottom-scripts.liquid
// on 2026-09-03 (was an inline <script type="module">). Loaded from bottom-scripts.liquid as
// <script src="{{ 'offer-bar.js' | asset_url }}" type="module">. Module scripts are always
// decoded as UTF-8, so the emoji in the messages below are safe as an external file.
  class OfferBar extends HTMLElement {
    static observedAttributes = ['subtotal'];

    tiers = [
      {
        amount: 149,
        discount: 15,
        icon: "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/Frame_52_1.png?v=1750420148",
      },
      {
        amount: 199,
        discount: 20,
        icon: "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/Frame_52_2.png?v=1750420287",
      },
      {
        amount: 249,
        discount: 25,
        icon: "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/Frame_52_3.png?v=1750420307",
      },
      {
        amount: 299,
        discount: 30,
        icon: "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/Frame_52_4.png?v=1750420498",
      },
      {
        amount: Infinity,
        discount: 30,
        icon: "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/Frame_52_4.png?v=1750420498",
      },
    ];

    constructor() {
      super()
      // Ported 2026-09-03 from Liquid `{% if template contains 'index' %}` (this file is a static
      // asset, Liquid is not evaluated). layout/theme.liquid stamps data-template="{{ template }}"
      // on <main id="MainContent">; `contains` was a substring test, so is includes().
      const main = document.getElementById('MainContent')
      const isHome = !!(main && (main.getAttribute('data-template') || '').includes('index'))
      this.innerHTML = `
  <div class="inset-x-0 top-0 z-50 text-sm ${isHome ? 'mt-[22px]' : ''} font-medium text-white shadow-md  sm:text-base"
       style="background:#1E4036!important">
    <div class="flex flex-col items-center justify-between max-w-screen-xl gap-2 px-4 py-2 mx-auto md:flex-row">
        <div class="flex items-center justify-between gap-1 sm:gap-4 "> 
      <!-- Icon -->
      <img id="tier-icon"
           src=""
           alt="Discount Tier"
           class="hidden w-8 h-8 border border-white rounded-full sm:w-10 sm:h-10 shrink-0" />

      <!-- Message -->
      <span id="msg"
            class="flex-1 px-2  md:text-[16px] text-[14px] overflow-hidden md:text-left  text-center text-ellipsis"></span>

            <!-- Countdown Timer -->
      <div class="hidden my-2 sm:mx-2 sm:my-0 ">
        <style>

       

            .digit-box {
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: white;
              border-radius: 2px;
              width: 16px;
              height: 24px;
              margin: 0 1px;
              color: black;
            }
            @media (min-width: 640px) {
              .digit-box {
                width: 20px;
                height: 28px;
              }
            }
              @media (min-width: 913px) {
              .digit-box {
                width: 25px;
                height: 33px;
              }
            }
            @media (min-width: 1065px) {
              .digit-box {
                width: 34px;
                height: 42px;
              }
            }
          </style>
          <div class="flex items-center px-2 sm:px-4 py-1.5 sm:py-2 rounded-md countdown-timer  shadow-inner   ">

          <div class="flex items-center justify-center w-full sm:gap-1">
            <div class="flex flex-col items-center">
              <div class="flex md:gap-1">
                <div class=" digit-box">
                  <span id="days-tens" class="font-bold text-center text-md md:text-2xl">0</span>
                </div>
                <div class=" digit-box">
                  <span id="days-ones" class="font-bold text-center text-md md:text-2xl">0</span>
                </div>
                
              </div>
             
            </div>
            <div class="text-md  md:text-2xl font-bold mx-0.5 text-white">:</div>
              <div class="flex flex-col items-center">
              <div class="flex md:gap-1">
            <div class="digit-box">
                  <span id="hours-tens" class="font-bold text-center text-md md:text-2xl">0</span>
                </div>
                <div class="digit-box">
                  <span id="hours-ones" class="font-bold text-center text-md md:text-2xl">0</span>
                </div>
                </div>
                </div>
            <div class="text-md  md:text-2xl font-bold mx-0.5 text-white">:</div>
            <div class="flex flex-col items-center">
              <div class="flex md:gap-1">
                <div class="digit-box">
                  <span id="minutes-tens" class="font-bold text-center text-md md:text-2xl">0</span>
                </div>
                <div class="digit-box">
                  <span id="minutes-ones" class="font-bold text-center text-md md:text-2xl">0</span>
                </div>
              </div>
              <div class="text-[8px] hidden sm:text-[10px] font-medium uppercase tracking-wider mt-1">Min</div>
            </div>
            <div class="text-md  md:text-2xl font-bold mx-0.5 text-white">:</div>
            <div class="flex flex-col items-center">
              <div class="flex md:gap-1">
                <div class="digit-box">
                  <span id="seconds-tens" class="font-bold text-center text-md md:text-2xl">0</span>
                </div>
                <div class="digit-box">
                  <span id="seconds-ones" class="font-bold text-center text-md md:text-2xl">0</span>
                </div>
              </div>
              <div class="text-[8px] hidden sm:text-[10px] font-medium uppercase tracking-wider mt-1">Sec</div>
            </div>
          </div>
        </div>
      </div>
            
      </div>
      
      
 
      <!-- Progress and tiers -->
      <div class="flex flex-col w-full gap-1 sm:w-1/3">
        <div class="h-2 mt-2 rounded bg-white/30">
          <div id="progress"
               class="h-2 transition-all duration-300 bg-white rounded"
               style="width:0%"></div>
        </div>
        <div class="flex justify-between text-[10px] text-white/80 tracking-tight px-1">
          <span>$149</span><span>$199</span><span>$249</span><span>$299</span>
        </div>
      </div>
    </div>
  </div>`

      this.$msg = this.querySelector('#msg')
      this.$progress = this.querySelector('#progress')
      this.$icon = this.querySelector('#tier-icon')
    }

    attributeChangedCallback() {
      this.render()
    }

    set subtotal(val) {
      this.setAttribute('subtotal', val)
    }

    get subtotal() {
      return parseFloat(this.getAttribute('subtotal') || '0')
    }

    render() {
      const subtotal = this.subtotal
      const nextTier = this.tiers.find(t => subtotal < t.amount)
      const currentTier = [...this.tiers].reverse().find(t => subtotal >= t.amount) || this.tiers[0]

      const remaining = nextTier && nextTier.amount !== Infinity ? (nextTier.amount - subtotal).toFixed(2) : null

      // Message
      if (subtotal == 0) {
        this.$msg.textContent = `Spend $299.00 reach 30% OFF`
      }
      else if (subtotal < 299) {
        this.$msg.textContent = `🌱 Spend $${(299 - subtotal).toFixed(2)} more for 30% OFF`
      } else if (nextTier && nextTier.amount !== Infinity) {
        // this.$msg.textContent = `👀 ${currentTier.discount}% OFF unlocked – Add $${remaining} to save ${nextTier.discount}%`
      } else {
        this.$msg.textContent = `🎉 Summer Sale Ends Soon - Save up to 30%.`
      }

      // Icon
      this.$icon.src = currentTier.icon

      // Progress
      this.$progress.style.width = `${Math.min((subtotal / 299) * 100, 100)}%`
    }

    connectedCallback() {
      this.render()
    }
  }

  customElements.define('offer-bar', OfferBar);
